import { combineReducers } from 'redux'
import * as TypeAction from './actionTypes'
import { reducerList, reducerCrud } from 'scorpion-core';


export default combineReducers({

    rLista: reducerList(TypeAction.LISTAR, TypeAction.CARREGAR_FORM),

    rCrudObj: reducerCrud(TypeAction.SALVAR_OBJ),
    rListaObj: reducerList(TypeAction.LISTAR_OBJ, null, true),


})


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicForms/reducer.js